"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function AddChapter(_a) {
    var mediaId = _a.mediaId, seconds = _a.seconds, _b = _a.clickedChapter, clickedChapter = _b === void 0 ? {} : _b, setModal = _a.setModal, modalClose = _a.modalClose, setChapters = _a.setChapters, _c = _a.chapters, chapters = _c === void 0 ? {} : _c, pointerTime = _a.pointerTime, setSubmitting = _a.setSubmitting, videoLength = _a.videoLength;
    var _d = storybook_1.Helpers.useSave('media', 'video_chapters', {
        id: clickedChapter.id,
        external_id: mediaId,
        title: clickedChapter.title || '',
        start_seconds: clickedChapter.start_seconds || 0,
        end_seconds: parseInt(clickedChapter.start_seconds) + 5 || 0,
    }, {}, {}, setChapters, chapters.data), chapter = _d[0], setChapter = _d[1], saveChapter = _d[2];
    function onSubmit() {
        saveChapter().then(function (response) {
            if (!response.errors.length) {
                setSubmitting(true);
                setSubmitting(false);
                modalClose();
            }
        });
    }
    var removeChapter = function () {
        setModal({
            content: function () { return react_1.default.createElement(storybook_1.Forms.DeleteModal, { title: 'Chapter', simple: true, api: 'media', route: 'video_chapters', params: { id: clickedChapter.id }, records: chapters.data, setRecords: setChapters, onDelete: modalClose, setSubmitting: setSubmitting }); },
        });
    };
    return react_1.default.createElement("div", { className: 'storybook-chapters-form' },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', appendClassname: 'mb-4' }, Boolean(clickedChapter.id) ? 'Hoofdstuk aanpassen' : 'Hoofdstuk Toevoegen'),
        react_1.default.createElement("form", { onSubmit: function (event) { return event.preventDefault(); } },
            react_1.default.createElement(storybook_1.Timelines.FormFields, { chapter: chapter.data, setChapter: setChapter, seconds: seconds, pointerTime: pointerTime, videoLength: videoLength }),
            react_1.default.createElement(storybook_1.Timelines.FormButtons, { model: chapter, active: clickedChapter, onDelete: removeChapter, onSubmit: onSubmit })));
}
exports.default = AddChapter;
